export default __webpack_public_path__ + "static/over-the-air-updates-d337ab64e43891396558afbf724ce13c.svg";